import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `FichaVerraco/putCambiarVigiladoSeleccion`, method: 'POST', body: {list}, token: token})
}
